var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CreateItem',{attrs:{"status":_vm.status,"model":"accessory","latest":_vm.latest}},[(_vm.status !== 'loading')?_c('FormAccessoryCreate'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }